<template>
	<div  v-loading="loading">
		<el-dialog  title="编辑" :visible.sync="dialogVisible" @close="close"   >
			
			<el-form label-width="80px">
				
				<el-form-item label="分类名">
				    <el-input v-model="form.name" style="width: 80%;"></el-input>
				</el-form-item>
				<el-form-item label="排序">
				    <el-input v-model="form.order"  style="width: 80%;"></el-input>
				</el-form-item>
			</el-form>
			
			<div style="height:30px"></div>
			<div style="height: 30px;text-align: center;">
				<el-button @click="tijiao" type="primary">保 存</el-button>
				 <el-button @click="close">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default{
	name:'Edit',
	props:{
		id:String,
		type:String
	},
	data(){
		return {
			dialogVisible:true,
			data:[],
			loading: false,
			form:{
				name:"",
				order:"",
			},
			headerObj:{
				token:sessionStorage.getItem("token")
			}
			
		}
	},
	methods:{
		
		close(){
			this.dialogVisible=false
			this.$emit("close")
		},
		async tijiao(){
			var url="/index/GoodsClassify/Edit";
			var res=await this.$post(url,this.form)
			if(res.errCode=="1"){
				this.$success(res,this)
				this.close();
			}else{
				this.$error(res,this)
			}
		},
		handleClick(tab, event){
		},
		async GetInfo(){
			var res=await this.$get("/index/GoodsClassify/Find",{"uuid":this.id})
			this.form=res.result;
		}
	},
	mounted(){
		if(this.id!="") this.GetInfo();
	}
}
</script>
<style scoped="scoped">
	div{
		text-align: left;
	}
	.text{
		width: 80%;
	}
</style>
<style>
	 .avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	  }
	  .avatar {
	    width: 178px;
	    height: 178px;
	    display: block;
	  }
	.zZindex {
	    z-index:9999 !important;
	}
</style>
